export * from "./InputSlider.types";

export { default } from "./InputSlider.vue";
